import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import checkNot from './utils/checkNot';

export default class MailerApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('auth'), options);
  }

  // =============================================================================
  //                                   MAILER APIs
  // =============================================================================

  public RetailerProductDataCompletionInvitationPost(
    message: any,
    notificationType?: string | number,
  ) {
    let query = '/mailer/v1/retailer/product/data/completion/invitation';
    query += '?alk=1';

    if (checkNot(notificationType, ['undefined', 'null', 'empty'])) {
      query += `&notification_type=${notificationType}`;
    }
    return this.post(query, message);
  }

  public MailerSend(mail: any) {
    const query = '/mailer/v1/send';
    return this.post(query, mail);
  }
}
